const swatchLabels = document.querySelectorAll(
  '.product__swatch-color-options .swatch__label'
);

const firstSwatchLabel = swatchLabels.length ? swatchLabels[0] : null;

if (firstSwatchLabel && firstSwatchLabel.textContent.trim().length > 9) {
  firstSwatchLabel.classList.add('swatch-label-multiple-line');
}